export const colors = {
  primary: '#1C1C21',
  primaryDark: '#292930',
  primaryLight: '#32323B',
  secondary: ' #606579;',
  secondaryLight: 'rgba(255, 176, 0, 0.4)',
  tertiary: '#025430',
  tertiaryDark: '#483B3B',
  quaternary: '#CCC6C6',
  secondaryBackground: '#2c4155',
  cardBack: '#025430',
  secondaryText: '#E83939',
  closeStrokeColor: '#3D6389',
  tetriaryBackground: '#38433D',
  white: '#FFFFFF',
  greyBorder: ' #545468',
  darkGreyBorder: '#35353F',
  errorBackground: 'rgba(37, 38, 45, 1)',
}

export const cyberColors = {
  black: '#1C1C21',
  red: '#E93434',
  darkRed: '#DB2E2E',
  blue: '#3054E5',
  darkBlue: '#1F3DB6',
  green: '#95CB9D',
  lightGreen: '#D3EAD7',
  darkGreen: '#214426',
  greyLight: '#32323B',
  greyMedium: '#32323C',
  greyDark: '#292930',
  greyText: '#606579',
  whiteText: '#FFFFFF',
  whiteDark: '#C4C9DD',
  blueText: '#7E97FA',
  redText: '#FA7E7E',
  redGradient:
    'linear-gradient(178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%)',
  greenGradient:
    'linear-gradient(178.89deg, #5C8D1D 14.22%, #5E911E 36.3%, #72AD27 99.05%)',
  blueGradient:
    'linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%)',
}

export const redGradient = `linear-gradient(
  322deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(238, 57, 57, 1) 82.72%,
  rgba(238, 57, 57, 1) 98.02%
);`

export const blueGradient = `linear-gradient(
  322deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(53,90,238,1) 82.72%,
  rgba(53,90,238,1) 98.02%
);`

export const greyGradient = `linear-gradient(
  322deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(61, 65, 81, 1) 82.72%,
  rgba(61, 65, 81, 1) 98.02%
);`

export const greenGradient = `linear-gradient(
  -322deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(114, 173, 39, 1) 82.72%,
  rgba(114, 173, 39, 1) 98.02%
);`
